import { createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeStyle as _normalizeStyle, Teleport as _Teleport, createBlock as _createBlock, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-aa69aced"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tpd-content-layout" }
const _hoisted_2 = { class: "dashboader-area mb-25" }
const _hoisted_3 = { class: "tp-dashboard-tab" }
const _hoisted_4 = { class: "tp-dashboard-tab-title" }
const _hoisted_5 = { class: "tp-dashboard-tab-list" }
const _hoisted_6 = { class: "course-area" }
const _hoisted_7 = {
  key: 0,
  class: "row"
}
const _hoisted_8 = { class: "tp-dashboard-course mb-25" }
const _hoisted_9 = { class: "tp-dashboard-course-thumb" }
const _hoisted_10 = ["src"]
const _hoisted_11 = { class: "tp-dashboard-course-content" }
const _hoisted_12 = { class: "tp-dashboard-rating d-flex align-items-center gap-2" }
const _hoisted_13 = { class: "course-star-rating star-rating-sm d-inline-block m-0" }
const _hoisted_14 = /*#__PURE__*/_createStaticVNode("<div class=\"back-stars\" data-v-aa69aced><i class=\"fa fa-star\" data-v-aa69aced></i><i class=\"fa fa-star\" data-v-aa69aced></i><i class=\"fa fa-star\" data-v-aa69aced></i><i class=\"fa fa-star\" data-v-aa69aced></i><i class=\"fa fa-star\" data-v-aa69aced></i></div>", 1)
const _hoisted_15 = /*#__PURE__*/_createStaticVNode("<i class=\"fa fa-star\" data-v-aa69aced></i><i class=\"fa fa-star\" data-v-aa69aced></i><i class=\"fa fa-star\" data-v-aa69aced></i><i class=\"fa fa-star\" data-v-aa69aced></i><i class=\"fa fa-star\" data-v-aa69aced></i>", 5)
const _hoisted_20 = [
  _hoisted_15
]
const _hoisted_21 = {
  class: "tp-dashboard-course-title",
  style: {"font-size":"18px"}
}
const _hoisted_22 = { class: "tp-dashboard-course-meta" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("svg", {
    width: "15",
    height: "14",
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M13.9228 10.0426V2.29411C13.9228 1.51825 13.2949 0.953997 12.5252 1.01445H12.4847C11.1276 1.12529 9.07163 1.82055 7.91706 2.53596L7.80567 2.6065C7.62337 2.71733 7.30935 2.71733 7.11692 2.6065L6.9549 2.50573C5.81046 1.79033 3.75452 1.1152 2.3974 1.00437C1.62768 0.943911 0.999756 1.51827 0.999756 2.28405V10.0426C0.999756 10.6573 1.50613 11.2417 2.12393 11.3122L2.30622 11.3425C3.70386 11.5238 5.87126 12.2392 7.10685 12.9143L7.1372 12.9244C7.30937 13.0252 7.59293 13.0252 7.75498 12.9244C8.99057 12.2393 11.1681 11.5339 12.5758 11.3425L12.7885 11.3122C13.4164 11.2417 13.9228 10.6674 13.9228 10.0426Z",
      stroke: "#94928E",
      "stroke-width": "1.2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M7.46118 2.81787V12.4506",
      stroke: "#94928E",
      "stroke-width": "1.2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    })
  ])
], -1 /* HOISTED */))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("svg", {
    width: "13",
    height: "15",
    viewBox: "0 0 13 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M6.57134 7.5C8.36239 7.5 9.81432 6.04493 9.81432 4.25C9.81432 2.45507 8.36239 1 6.57134 1C4.7803 1 3.32837 2.45507 3.32837 4.25C3.32837 6.04493 4.7803 7.5 6.57134 7.5Z",
      stroke: "#94928E",
      "stroke-width": "1.2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M12.1426 14C12.1426 11.4845 9.64553 9.44995 6.57119 9.44995C3.49684 9.44995 0.999756 11.4845 0.999756 14",
      stroke: "#94928E",
      "stroke-width": "1.2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    })
  ])
], -1 /* HOISTED */))
const _hoisted_25 = { class: "tp-dashboard-progress hidden" }
const _hoisted_26 = { class: "tp-dashboard-progress-info d-flex align-items-center justify-content-between" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "3/4", -1 /* HOISTED */))
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "progress",
  role: "progressbar",
  "aria-label": "Example",
  "aria-valuenow": "25",
  "aria-valuemin": "0",
  "aria-valuemax": "100"
}, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "progress-bar wow fadeInLeft",
    "data-wow-duration": ".9s",
    "data-wow-delay": ".3s",
    "data-width": " 75%"
  })
], -1 /* HOISTED */))
const _hoisted_29 = { class: "tp-dashboard-course-btn" }
const _hoisted_30 = /*#__PURE__*/_createStaticVNode("<div class=\"placeholder-glow col-xl-4 col-md-6\" data-v-aa69aced><span class=\"placeholder rounded\" style=\"width:100%;height:420px;\" data-v-aa69aced></span></div><div class=\"placeholder-glow col-xl-4 col-md-6\" data-v-aa69aced><span class=\"placeholder rounded\" style=\"width:100%;height:420px;\" data-v-aa69aced></span></div><div class=\"placeholder-glow col-xl-4 col-md-6\" data-v-aa69aced><span class=\"placeholder rounded\" style=\"width:100%;height:420px;\" data-v-aa69aced></span></div>", 3)
const _hoisted_33 = {
  key: 2,
  class: "col-12"
}
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "alert alert-warning" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "far fa-info-circle mr-1" }),
  /*#__PURE__*/_createTextVNode(" Not Courses Found ")
], -1 /* HOISTED */))
const _hoisted_35 = [
  _hoisted_34
]
const _hoisted_36 = {
  key: 1,
  class: "row"
}
const _hoisted_37 = { class: "col-12" }
const _hoisted_38 = {
  key: 0,
  class: "tp-dashboard-course mb-25"
}
const _hoisted_39 = { class: "card-header font-w-600" }
const _hoisted_40 = { class: "list-group list-group-flush" }
const _hoisted_41 = ["onClick"]
const _hoisted_42 = { class: "text-dark" }
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "far fa-video me-1" }, null, -1 /* HOISTED */))
const _hoisted_44 = {
  key: 0,
  class: "far fa-play text-secondary"
}
const _hoisted_45 = ["onClick"]
const _hoisted_46 = { class: "text-dark" }
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "far fa-file-pdf me-1" }, null, -1 /* HOISTED */))
const _hoisted_48 = {
  key: 0,
  class: "far fa-search text-secondary"
}
const _hoisted_49 = ["href", "target"]
const _hoisted_50 = { class: "text-dark" }
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "far fa-link me-1" }, null, -1 /* HOISTED */))
const _hoisted_52 = {
  key: 0,
  class: "far fa-external-link text-secondary"
}
const _hoisted_53 = {
  key: 1,
  class: "alert alert-warning"
}
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "far fa-info-circle mr-1" }, null, -1 /* HOISTED */))
const _hoisted_55 = {
  class: "modal fade",
  id: "resourceViewModal",
  "data-bs-backdrop": "static",
  "data-bs-keyboard": "false",
  tabindex: "-1",
  "aria-labelledby": "resourceViewModalLabel",
  "aria-hidden": "true"
}
const _hoisted_56 = { class: "modal-content" }
const _hoisted_57 = { class: "modal-header" }
const _hoisted_58 = {
  class: "modal-title fs-5",
  id: "resourceViewModalLabel"
}
const _hoisted_59 = { class: "ms-auto" }
const _hoisted_60 = {
  key: 0,
  class: "far fa-expand"
}
const _hoisted_61 = {
  key: 1,
  class: "far fa-compress"
}
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn-close",
  "data-bs-dismiss": "modal",
  "aria-label": "Close"
}, null, -1 /* HOISTED */))
const _hoisted_63 = { class: "modal-body" }
const _hoisted_64 = {
  key: 0,
  controls: "",
  controlsList: "nodownload",
  style: {"width":"100%","height":"100%"}
}
const _hoisted_65 = ["src"]
const _hoisted_66 = {
  key: 1,
  class: "google-drive-iframe"
}
const _hoisted_67 = ["src"]
const _hoisted_68 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { id: "PDFViewer" }, null, -1 /* HOISTED */))
const _hoisted_69 = [
  _hoisted_68
]
const _hoisted_70 = {
  key: 1,
  class: "google-drive-iframe"
}
const _hoisted_71 = ["src"]
const _hoisted_72 = {
  key: 2,
  class: "alert alert-warning"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_router_link = _resolveComponent("router-link")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createCommentVNode(" dashboard-content-area-start "),
    _createElementVNode("div", _hoisted_1, [
      _createCommentVNode(" dashboard-tab-area "),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("h2", _hoisted_4, _toDisplayString($data.lms_website.__('Enrolled Courses')), 1 /* TEXT */),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("ul", null, [
              _createElementVNode("li", null, [
                _createElementVNode("a", {
                  class: _normalizeClass(["pointer-event", ($data.courses.active_tab==='in_progress')?'active':'']),
                  onClick: _cache[0] || (_cache[0] = $event => ($data.courses.active_tab='in_progress'))
                }, [
                  _createTextVNode(_toDisplayString($data.lms_website.__('Enrolled Courses')) + " ", 1 /* TEXT */),
                  _createElementVNode("span", null, "(" + _toDisplayString($data.courses.in_progress.length) + ")", 1 /* TEXT */)
                ], 2 /* CLASS */)
              ]),
              _createElementVNode("li", null, [
                _createElementVNode("a", {
                  class: _normalizeClass(["pointer-event", ($data.courses.active_tab==='completed')?'active':'']),
                  onClick: _cache[1] || (_cache[1] = $event => ($data.courses.active_tab='completed'))
                }, [
                  _createTextVNode(_toDisplayString($data.lms_website.__('Completed')) + " ", 1 /* TEXT */),
                  _createElementVNode("span", null, "(" + _toDisplayString($data.courses.completed.length) + ")", 1 /* TEXT */)
                ], 2 /* CLASS */)
              ]),
              _createElementVNode("li", null, [
                _createElementVNode("a", {
                  class: _normalizeClass(["pointer-event", ($data.courses.active_tab==='resources')?'active':'']),
                  onClick: _cache[2] || (_cache[2] = $event => ($data.courses.active_tab='resources'))
                }, [
                  _createTextVNode(_toDisplayString($data.lms_website.__('Resources')) + " ", 1 /* TEXT */),
                  _createElementVNode("span", null, "(" + _toDisplayString($options.totalResources) + ")", 1 /* TEXT */)
                ], 2 /* CLASS */)
              ])
            ])
          ])
        ])
      ]),
      _createCommentVNode(" dashboard-tab-area-end "),
      _createCommentVNode(" course-area-start "),
      _createElementVNode("div", _hoisted_6, [
        ($data.courses.active_tab!=='resources')
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              ($options.activeCourses.length)
                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList($options.activeCourses, (course) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: course.name,
                      class: "col-xl-4 col-md-6"
                    }, [
                      _createElementVNode("div", _hoisted_8, [
                        _createElementVNode("div", _hoisted_9, [
                          _createVNode(_component_router_link, {
                            to: `/courses/view/${course.name}`
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("img", {
                                src: (course.image)?course.image:'/assets/lms_website/images/placeholder.jpg',
                                alt: ""
                              }, null, 8 /* PROPS */, _hoisted_10)
                            ]),
                            _: 2 /* DYNAMIC */
                          }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["to"])
                        ]),
                        _createElementVNode("div", _hoisted_11, [
                          _createElementVNode("div", _hoisted_12, [
                            _createElementVNode("div", _hoisted_13, [
                              _hoisted_14,
                              _createElementVNode("div", {
                                class: "front-stars",
                                style: _normalizeStyle('width:'+$options.avg_rating_width(course.avg_rating))
                              }, _hoisted_20, 4 /* STYLE */)
                            ]),
                            _createElementVNode("span", null, "(" + _toDisplayString(course.reviews_count) + " " + _toDisplayString($data.lms_website.__('Reviews')) + ")", 1 /* TEXT */)
                          ]),
                          _createElementVNode("h4", _hoisted_21, [
                            _createVNode(_component_router_link, {
                              to: `/courses/view/${course.name}`
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString($options.clip(course.title, 60)), 1 /* TEXT */)
                              ]),
                              _: 2 /* DYNAMIC */
                            }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["to"])
                          ]),
                          _createElementVNode("div", _hoisted_22, [
                            _createElementVNode("span", null, [
                              _hoisted_23,
                              _createTextVNode(" " + _toDisplayString(course.lesson_count) + " " + _toDisplayString($data.lms_website.__('Lessons')), 1 /* TEXT */)
                            ]),
                            _createElementVNode("span", null, [
                              _hoisted_24,
                              _createTextVNode(" " + _toDisplayString(course.enrollment_count) + " " + _toDisplayString($data.lms_website.__('Students')), 1 /* TEXT */)
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_25, [
                            _createElementVNode("div", _hoisted_26, [
                              _hoisted_27,
                              _createElementVNode("span", null, "85% " + _toDisplayString($data.lms_website.__('Complete')), 1 /* TEXT */)
                            ]),
                            _hoisted_28
                          ]),
                          _createElementVNode("div", _hoisted_29, [
                            _createVNode(_component_router_link, {
                              class: "tpd-btn-border w-100",
                              to: `/courses/view/${course.name}`
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString($data.lms_website.__('View Course')), 1 /* TEXT */)
                              ]),
                              _: 2 /* DYNAMIC */
                            }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["to"])
                          ])
                        ])
                      ])
                    ]))
                  }), 128 /* KEYED_FRAGMENT */))
                : _createCommentVNode("v-if", true),
              ($data.courses.loading)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _hoisted_30
                  ], 64 /* STABLE_FRAGMENT */))
                : _createCommentVNode("v-if", true),
              (!$options.activeCourses.length && !$data.courses.loading)
                ? (_openBlock(), _createElementBlock("div", _hoisted_33, _hoisted_35))
                : _createCommentVNode("v-if", true)
            ]))
          : _createCommentVNode("v-if", true),
        ($data.courses.active_tab==='resources')
          ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
              _createElementVNode("div", _hoisted_37, [
                ($data.courses.resources?.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.courses.resources, (resource, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: _normalizeClass(["card", {'mb-2':((index+1)<$data.courses.resources.length)}]),
                          key: resource.parent
                        }, [
                          _createElementVNode("div", _hoisted_39, _toDisplayString(resource.title), 1 /* TEXT */),
                          _createElementVNode("div", _hoisted_40, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(resource.resources, (item) => {
                              return (_openBlock(), _createElementBlock(_Fragment, {
                                key: item.name
                              }, [
                                (item.link_type==='Attach Video')
                                  ? (_openBlock(), _createElementBlock("a", {
                                      key: 0,
                                      onClick: $event => ($options.openResource(item)),
                                      class: "list-group-item list-group-item-action d-flex align-items-center justify-between pointer-event"
                                    }, [
                                      _createElementVNode("span", _hoisted_42, [
                                        _hoisted_43,
                                        _createTextVNode(" " + _toDisplayString(item.title), 1 /* TEXT */)
                                      ]),
                                      (item.attach_file)
                                        ? (_openBlock(), _createElementBlock("i", _hoisted_44))
                                        : _createCommentVNode("v-if", true)
                                    ], 8 /* PROPS */, _hoisted_41))
                                  : (item.link_type==='PDF')
                                    ? (_openBlock(), _createElementBlock("a", {
                                        key: 1,
                                        onClick: $event => ($options.openResource(item)),
                                        class: "list-group-item list-group-item-action d-flex align-items-center justify-between pointer-event"
                                      }, [
                                        _createElementVNode("span", _hoisted_46, [
                                          _hoisted_47,
                                          _createTextVNode(" " + _toDisplayString(item.title), 1 /* TEXT */)
                                        ]),
                                        (item.attach_file)
                                          ? (_openBlock(), _createElementBlock("i", _hoisted_48))
                                          : _createCommentVNode("v-if", true)
                                      ], 8 /* PROPS */, _hoisted_45))
                                    : (_openBlock(), _createElementBlock("a", {
                                        key: 2,
                                        href: item.url || '#',
                                        target: item.url?'_blank':null,
                                        class: "list-group-item list-group-item-action d-flex align-items-center justify-between"
                                      }, [
                                        _createElementVNode("span", _hoisted_50, [
                                          _hoisted_51,
                                          _createTextVNode(" " + _toDisplayString(item.title), 1 /* TEXT */)
                                        ]),
                                        (item.url)
                                          ? (_openBlock(), _createElementBlock("i", _hoisted_52))
                                          : _createCommentVNode("v-if", true)
                                      ], 8 /* PROPS */, _hoisted_49))
                              ], 64 /* STABLE_FRAGMENT */))
                            }), 128 /* KEYED_FRAGMENT */))
                          ])
                        ], 2 /* CLASS */))
                      }), 128 /* KEYED_FRAGMENT */))
                    ]))
                  : _createCommentVNode("v-if", true),
                (!$data.courses.resources?.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_53, [
                      _hoisted_54,
                      _createTextVNode(" Not Resources Found ")
                    ]))
                  : _createCommentVNode("v-if", true)
              ])
            ]))
          : _createCommentVNode("v-if", true)
      ]),
      _createCommentVNode(" course-area-start-end "),
      (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
        _createElementVNode("div", _hoisted_55, [
          _createElementVNode("div", {
            class: _normalizeClass(["modal-dialog modal-dialog-scrollable", {'modal-fullscreen':($data.resourceModal.full_screen),'modal-xl':(!$data.resourceModal.full_screen)}])
          }, [
            _createElementVNode("div", _hoisted_56, [
              _createElementVNode("div", _hoisted_57, [
                _createElementVNode("h1", _hoisted_58, _toDisplayString($data.resourceModal.resource?.title), 1 /* TEXT */),
                _createElementVNode("div", _hoisted_59, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn btn-full-screen",
                    onClick: _cache[3] || (_cache[3] = $event => ($data.resourceModal.full_screen=!$data.resourceModal.full_screen))
                  }, [
                    (!$data.resourceModal.full_screen)
                      ? (_openBlock(), _createElementBlock("i", _hoisted_60))
                      : _createCommentVNode("v-if", true),
                    ($data.resourceModal.full_screen)
                      ? (_openBlock(), _createElementBlock("i", _hoisted_61))
                      : _createCommentVNode("v-if", true)
                  ]),
                  _hoisted_62
                ])
              ]),
              _createElementVNode("div", _hoisted_63, [
                ($data.resourceModal.resource?.link_type==='Attach Video')
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      (!$options.isGoogleDriveLink($data.resourceModal.resource?.attach_file))
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            ($data.resourceModal.resource?.attach_file)
                              ? (_openBlock(), _createElementBlock("video", _hoisted_64, [
                                  _createElementVNode("source", {
                                    src: $data.resourceModal.resource?.attach_file,
                                    type: "audio/ogg"
                                  }, null, 8 /* PROPS */, _hoisted_65),
                                  _createTextVNode(" " + _toDisplayString($data.lms_website.__('Your browser does not support the video tag.')), 1 /* TEXT */)
                                ]))
                              : _createCommentVNode("v-if", true)
                          ], 64 /* STABLE_FRAGMENT */))
                        : _createCommentVNode("v-if", true),
                      ($options.isGoogleDriveLink($data.resourceModal.resource?.attach_file))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_66, [
                            ($data.resourceModal.resource?.attach_file)
                              ? (_openBlock(), _createElementBlock("iframe", {
                                  key: 0,
                                  class: "custom-iframe",
                                  src: $options.googleDriveLinkPreview($data.resourceModal.resource?.attach_file),
                                  style: {"width":"100%","border":"0","border-radius":"10px"}
                                }, null, 8 /* PROPS */, _hoisted_67))
                              : _createCommentVNode("v-if", true)
                          ]))
                        : _createCommentVNode("v-if", true)
                    ], 64 /* STABLE_FRAGMENT */))
                  : _createCommentVNode("v-if", true),
                ($data.resourceModal.resource?.link_type==='PDF')
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      (!$options.isGoogleDriveLink($data.resourceModal.resource?.attach_file))
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            class: _normalizeClass(["pdf-viewer", (!$data.resourceModal.file_loaded)?'is-loading':''])
                          }, _hoisted_69, 2 /* CLASS */))
                        : _createCommentVNode("v-if", true),
                      ($options.isGoogleDriveLink($data.resourceModal.resource?.attach_file))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_70, [
                            ($data.resourceModal.resource?.attach_file)
                              ? (_openBlock(), _createElementBlock("iframe", {
                                  key: 0,
                                  class: "custom-iframe",
                                  src: $options.googleDriveLinkPreview($data.resourceModal.resource?.attach_file),
                                  style: {"width":"100%","border":"0","border-radius":"10px"}
                                }, null, 8 /* PROPS */, _hoisted_71))
                              : _createCommentVNode("v-if", true)
                          ]))
                        : _createCommentVNode("v-if", true),
                      (!$data.resourceModal.resource?.attach_file)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_72, _toDisplayString($data.lms_website.__('PDF file url not found')), 1 /* TEXT */))
                        : _createCommentVNode("v-if", true)
                    ], 64 /* STABLE_FRAGMENT */))
                  : _createCommentVNode("v-if", true)
              ])
            ])
          ], 2 /* CLASS */)
        ])
      ]))
    ]),
    _createCommentVNode(" dashboard-content-area-end ")
  ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
}